import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween, FlexCenter, LineClamp } from '../../../global/commonStyle';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 280px;
  max-width: 280px;
  border-right: 0.5px solid var(--border-primary);
  height: 100%;
  position: sticky;
  left: 0;
  background-color: var(--background-secondary);
  z-index: var(--z-index-base);
`;

export const MemberItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-12);
  padding: var(--space-20) var(--space-24);
  box-shadow: var(--bottom-border);
  &:last-child {
    border-bottom: unset;
  }
`;

export const LeftSection = styled.div`
  ${FlexCenter}
  padding-top: var(--space-4);
`;

export const MemberMeta = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;

export const NameTimeGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

export const MemberHoursGroup = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
`;

export const MemberName = styled.p`
  width: 100%;
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  /* css for ellipsis */
  ${LineClamp(1)}
  text-overflow: ellipsis;
  word-break: break-all;
`;
export const TotalHours = styled.p`
  display: flex;
  justify-content: flex-end;
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  white-space: nowrap;
`;

export const TimeRow = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

export const TimeText = styled.p`
  ${Typography.body_md_medium}
  margin: var(--space-0);
  &.working-hours {
    color: var(--green);
    padding-right: var(--space-7);
    border-right: 1px solid var(--border-primary);
    &.no-border {
      border-right: unset;
      padding-right: var(--space-0);
    }
  }
  &.overload {
    color: var(--red);
  }
`;

export const CountRow = styled.div`
  display: flex;
  gap: var(--space-14);
`;

export const Counter = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

export const CountText = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

export const Icon = styled.div`
  ${FlexCenter}
`;
